import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { clinicState } from '../../../store/clinicState';
import { clinicServiceState } from '../../../store/clinicServiceState';

import { ClinicServiceRegularForm } from './ClinicServiceRegularForm';
import { ClinicServiceDockForm } from './ClinicServiceDockForm';
import { ClinicServiceSelectForm } from './ClinicServiceSelectForm';

export const ClinicServiceForm = (props) => {
  const { init_clinic_services, options } = props;
  const [clinicData, setClinicData] = useRecoilState(clinicState);
  const [clinicServiceData, setClinicServiceData] = useRecoilState(clinicServiceState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickClinicServiceUpsert = () => {
    console.log("onClickClinicServiceUpsert");
    var data = { clinic_id: clinicData.id };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/clinic_services_upsert`, data)
    .then(resp => {
      console.log("ClinicService Update api ok");
      console.log(resp.data);
      setClinicServiceData(resp.data.clinic_services);
      notify("success", "ClinicService Update Success!");
    })
    .catch(e => {
      console.log("ClinicService Update api ng");
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ClinicService Update Error!");
    });
  }

  return (
    <>
      <div className="card mt-3">
        <div className="card-header">
          <div className="row">
            <div className="col-auto me-auto h4 mt-1">受診情報</div>
            <div className="col-auto">
              <button 
                className="btn btn-success text-white" 
                onClick={onClickClinicServiceUpsert}
                disabled={clinicServiceData.length > 0 ? true : false}
              >
                コース一括生成
              </button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="accordion mb-3" id="accordionPanelsStayOpenClinicService">
            {clinicServiceData.map(clinic_service => {
              {if (clinic_service.cource_type === 0) {
                return <ClinicServiceRegularForm key={clinic_service.id}  init_clinic_service={clinic_service} />
              } else if (clinic_service.cource_type === 1) {
                return <ClinicServiceDockForm key={clinic_service.id}  init_clinic_service={clinic_service} options={options} />
              } else if (clinic_service.cource_type === 2) {
                return <ClinicServiceSelectForm key={clinic_service.id}  init_clinic_service={clinic_service} options={options} />
              }}
            })}
          </div>
        </div>

      </div>
    </>
  );
};